import { Component, Input } from '@angular/core';
import { RippleConfig } from '../ripple/index';
export class CbjButtonComponent {
  link: string;
  raised: boolean;
  text: string;
  btnClasses: string[] = [];
  rippleConf: RippleConfig;
  arrow: boolean;
/**
 * @return {?}
 */
classes() {
    return  [ ...this.btnClasses, 'btn', this.raised ? 'btn-raised' : 'btn-flat' ];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-button',
  template: `
    <ng-container *ngIf="link; else elseBlock">
      <a [cbjRipple]="rippleConf"
         [routerLink]="link"
         [ngClass]="classes()">
        {{text}}
        <i *ngIf="arrow" class="material-icons md-1">keyboard_arrow_down</i>
      </a>
    </ng-container>
    <ng-template #elseBlock>
      <button [cbjRipple]="rippleConf"
              [ngClass]="classes()">

        <ng-content></ng-content>
        <i *ngIf="arrow" class="material-icons md-1">keyboard_arrow_down</i>

      </button>
    </ng-template>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'link': [{ type: Input, args: ['link', ] },],
'raised': [{ type: Input, args: ['raised', ] },],
'text': [{ type: Input, args: ['text', ] },],
'btnClasses': [{ type: Input, args: ['btnClasses', ] },],
'rippleConf': [{ type: Input, args: ['rippleConf', ] },],
'arrow': [{ type: Input, args: ['arrow', ] },],
};
}

function CbjButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjButtonComponent.ctorParameters;
/** @type {?} */
CbjButtonComponent.propDecorators;
/** @type {?} */
CbjButtonComponent.prototype.link;
/** @type {?} */
CbjButtonComponent.prototype.raised;
/** @type {?} */
CbjButtonComponent.prototype.text;
/** @type {?} */
CbjButtonComponent.prototype.btnClasses;
/** @type {?} */
CbjButtonComponent.prototype.rippleConf;
/** @type {?} */
CbjButtonComponent.prototype.arrow;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
